<template>
  <div>
    <QuickFixDialogBase
      v-model="inputedValue"
      :title="title"
      :width="width"
      :pageData="pageData"
      isCardColor="true"
      @register="register"
    >
      <template v-slot:[pageData[0].name]>
        <v-container fluid class="pa-0">
          <v-row no-gutters class="ma-10">
            <v-col cols="5" class="mr-16">
              <InputFormNew
                :heading="$t('ship.ship_ship-info')"
                v-model="pageInfoData.line1"
                :detail="pageInfoDetail.line1"
                :titleCols="inputFormStyle.titleCols"
                :contentsCols="inputFormStyle.contentsCols"
              >
              </InputFormNew>
            </v-col>
            <v-col cols="5">
              <InputFormNew
                :heading="$t('common.input_recipient-info')"
                v-model="pageInfoData.line2"
                :detail="pageInfoDetail.line2"
                :titleCols="inputFormStyle.titleCols"
                :contentsCols="inputFormStyle.contentsCols"
              >
              </InputFormNew>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </QuickFixDialogBase>
  </div>
</template>
<script>
import QuickFixDialogBase from './QuickFixDialogBase'
import headers from '@/views/sales/Ship/headers'

import InputFormNew from '@/components/items/Designs/InputFormNew'
import { mapActions } from 'vuex'

export default {
  components: {
    QuickFixDialogBase,
    InputFormNew
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    recItems: {
      type: Object,
      require: true,
      default: () => ({})
    },
    pageInfoData: {}
  },
  data: () => ({
    pageData: [],

    // Design
    inputFormStyle: {
      rowHeight: '40px',
      titleCols: 3,
      contentsCols: 12 - 3,
      inputItemHeight: '32px'
    },
    pageInfoDetail: {
      line1: [
        {
          name: 'controlNumber',
          text: 'ship.ship_ship-history',
          component: 'text'
        },
        {
          name: 'customerName',
          text: 'sale.sale_customer',
          component: 'text'
        },
        {
          name: 'storageName',
          text: 'ship.ship_ship-storage',
          component: 'text'
        },
        {
          name: 'shipDate',
          text: 'ship.ship_ship-date',
          component: 'text'
        },
        {
          name: 'trackingNumber',
          text: 'ship.ship_tracking-number'
        },
        {
          name: 'remarks',
          text: 'common.input_remarks',
          textPositionStart: true,
          component: 'Remarks'
        }
      ],
      line2: [
        {
          name: 'fullName',
          text: 'common.input_name'
        },
        {
          name: 'organizationName',
          text: 'user.user_company-name'
        },
        {
          name: 'phone',
          text: 'common.input_phone-number',
          component: 'PhoneNumberInput'
        },
        {
          name: 'country',
          text: 'common.input_country',
          cols: Math.ceil((12 - 3) / 2),
          component: 'SelectCountry'
        },
        {
          name: 'postalCode',
          text: 'common.input_postal-code',
          cols: Math.ceil((12 - 3) / 2)
        },
        {
          name: 'region',
          text: 'common.input_region',
          cols: Math.ceil((12 - 3) / 2),
          component: 'SelectRegion'
        },
        {
          name: 'address1',
          text: 'common.input_address_1'
        },
        {
          name: 'address2',
          text: 'common.input_address_2'
        }
      ]
    }
  }),
  created() {
    this.ini()
  },
  methods: {
    ...mapActions('Ship', ['editShip']),
    ini() {
      this.pageData = [
        {
          title: 'ship.ship_ship-info',
          name: 'shipInfo',
          items: [],
          itemKey: ''
        },
        {
          title: 'ship.ship_ship-product',
          name: 'shipProduct',
          productHeaders: headers.productListHeaders,
          itemKey: headers.tableKey,
          items: this.recItems.productMoves
        }
      ]
    },
    async register() {
      const isSucceed = await this.editShip({
        pageInfoData: this.pageInfoData,
        id: this.recItems.shipId
      })
      if (isSucceed) {
        alert(this.$t('common.common_saved-alert'))
        this.inputedValue.dialog = false
        this.$emit('sumit')
      }
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
